import React, { useCallback, useState } from 'react'
import classnames from 'classnames'

import WarningDot from 'components/Profile/WarningDot'
import ProfileErrorMessage from 'components/Profile/ProfileErrorMessage'
import { FORM_CONTROL_CLASS } from 'components/Profile/constants'

const ProfileTextarea = ({ showRequired, minLength, classNames, onChange, ...rest }) => {
  const [error, setError] = useState('')

  const handleChange = useCallback(
    e => {
      onChange(e)

      if (minLength && !isNaN(minLength) && e.target.value.length < +minLength) {
        const error = `Please enter a minimum of ${minLength} characters`

        e.target.setCustomValidity(error)
        e.target.checkValidity(e)
        setError(error)
      } else {
        e.target.setCustomValidity('')
        setError('')
      }

      // e.target.reportValidity()
    },
    [minLength, onChange]
  )

  return (
    <div className="relative">
      <textarea
        className={classnames(FORM_CONTROL_CLASS, classNames.input, 'h-24')}
        minLength={minLength}
        onChange={handleChange}
        {...rest}
      />
      {showRequired && !rest.value && <WarningDot className="absolute top-4 right-4 transform" />}
      {error && <ProfileErrorMessage>{error}</ProfileErrorMessage>}
    </div>
  )
}

ProfileTextarea.defaultProps = {
  classNames: {
    input: 'md:text-center',
  },
}

export default ProfileTextarea
